import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationCreateOrganizationPort = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuid, portData }) => {
            return client.post(
                replaceParameters(ORGANIZATION.PORT.url, { uuid }),
                { port: portData }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreateOrganizationPort;
